
/**
 * Insert an HTML <img> element to a HTML <canvas> element
 * @param
 * @param
 * @return
 */
export function imgToCanvas(img, format, options) {
  let canvas           = document.createElement('canvas');
  canvas.width         = img.naturalWidth;
  canvas.height        = img.naturalHeight;
  let renderingContext = canvas.getContext("2d");

  renderingContext.drawImage(img, 0, 0);
  return canvas.toDataURL('image/' + format);
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/pdf_helper.js